<div id="app-header">
    <div class="container">
        <h1><a routerLink="/" style="color: #525352;">Guest Identity Manager</a></h1>
    </div>
    
</div>

<main role="main" class="site-content container">
    <section id="page-content">
        <mat-sidenav-container>
            <mat-sidenav #sideNav role="navigation">
                <mat-list>
                    <!-- <mat-list-item><a routerLink="" (click)="sideNav.close()"><mat-icon>home</mat-icon></a></mat-list-item>             -->
                    <mat-list-item>
                        <app-menu></app-menu>
                        <app-user class="user"></app-user>
                    </mat-list-item>
                </mat-list>
            </mat-sidenav>
            <mat-sidenav-content class="side-nav-content">
                <div class="menu">
                    <div>
                        <mat-toolbar class="toolbar">
                            <button mat-icon-button (click)="sideNav.open()">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                        </mat-toolbar>
                    </div>
                    <div>
                        <mat-toolbar class="toolbar">
                            <!-- <a mat-button routerLink=""><mat-icon>home</mat-icon></a>                                         -->
                            <app-menu></app-menu>
                            <app-user class="user"></app-user>
                        </mat-toolbar>
                    </div>
                </div>
                <div class="main-router-outlet">
                    <router-outlet></router-outlet>
                </div>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </section>
</main> <!-- end site-content -->